import {
  AnyAccountId,
  AccountIdentity,
  anyAccountId,
  accountIdentity,
  roomId,
  RoomId,
  streamIsActive,
  streamId,
  streamKinds,
  StreamIsActive,
  StreamId,
  StreamKind,
  roomContextId,
  RoomContextId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamUpdateEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamUpdateEventVO.validationSchema()
  );

  constructor(readonly value: RoomStreamUpdateEventVORaw) {
    JsonSchemaValidator.assert(RoomStreamUpdateEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: [
        "accountId",
        "accountIdentity",
        "roomId",
        "roomContextId",
        "streamIsActive",
        "streamId",
        "streamKinds"
      ],
      properties: {
        accountId: anyAccountId,
        accountIdentity: accountIdentity,
        roomId,
        roomContextId,
        streamIsActive,
        streamId,
        streamKinds
      },
      additionalProperties: false
    };
  }
}

interface RoomStreamUpdateEventVORaw {
  accountId: AnyAccountId;
  accountIdentity: AccountIdentity;
  roomId: RoomId;
  roomContextId: RoomContextId;
  streamIsActive: StreamIsActive;
  streamId: StreamId;
  streamKinds: StreamKind[];
}
